import React from 'react';
import { connect } from 'react-redux';
import * as actTableManagement from 'actions/tableManagement';
import ConfirmActionModal from 'components/ConfirmActionModal';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import { browserHistory } from 'react-router';
import { isDirty } from 'redux-form';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import List from './List';
import GroupDetail from './GroupDetail';
import ActionBar from './ActionBar';
import './TableManagementGroup.css';

class TableManagementGroup extends React.Component {
  componentDidMount() {
    this.props.dispatch(actTableManagement.groupPageRequest());
    browserHistory.listenBefore(location => {
      if (this.props.isDirtyTableGroup && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location.pathname)));
        return false;
      }
    });
  }

  render() {
    const { tableManagementGroup, loadingSpinner } = this.props.data;
    const {
      openRightColumn,
      showDeleteModal,
      deletedGroup,
      filteredGroups,
    } = tableManagementGroup;
    const { showLoadingSpinnerPage } = loadingSpinner;
    const groupName = deletedGroup ? deletedGroup.name : '';
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={filteredGroups.length === 0}
              title="Table Group Not Available"
              description="You can create table group by clicking Create Table Group button on top"
            />
            {!showLoadingSpinnerPage && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <GroupDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title="Group"
          name={groupName}
          onDelete={this._onDelete}
          description="This action will delete all table contained under this table group and cannot be undone"
        />
        <ConfirmActionModal />
      </PageWrapper>
    );
  }

  _onDelete = () => {
    const {
      groups,
      deletedGroup,
      groupDetail,
    } = this.props.data.tableManagementGroup;
    this.props.dispatch(
      actTableManagement.deleteGroup(deletedGroup.id, groups, groupDetail)
    );
  };

  _onHideModal = () => {
    this.props.dispatch(actTableManagement.cancelDelete());
  };
}

function mapStateToProps(state) {
  const isDirtyTableGroup = isDirty('table-management-group')(state);
  return {
    data: {
      tableManagementGroup: state.tableManagement.group,
      loadingSpinner: state.loadingSpinner,
    },
    nextAction: state.confirmAction.nextAction,
    isDirtyTableGroup,
  };
}

export default connect(mapStateToProps)(TableManagementGroup);
